import { observable, action, runInAction } from "mobx";

import RootStore from "app/RootStore";
import AdService from "contexts/adCampaigns/AdService";

export default class AdStore {
  /**
   * Map of lawyer IDs to lawyer names.
   * @type {Record<string, string>}
   * @example { "11": "Sevil Ozisik", "25": "Thomas Holler" }
   * @memberof AdStore
   */
  @observable public dataMapLawyer: Record<string, string> = {};

  private rootStore: RootStore;
  private adService: AdService;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.adService = new AdService();
  }

  @action
  async getLawyers() {
    const { results } = await this.adService.fetchLawyers();
    runInAction(() => {
      this.dataMapLawyer = results
        .filter((x) => x.isActive)
        .reduce(
          (acc, x: ResLawyer) => ({
            ...acc,
            [x.lawyerId]: x.name,
          }),
          {},
        );
    });
  }
}
